package er.prateek.crossly.persistence

import com.russhwolf.settings.Settings

private const val KEY_PLAY_COACH_SEEN = "coach_play_seen"
private const val KEY_LEVELS_COACH_SEEN = "coach_levels_seen"
private const val KEY_RESUME_COACH_SEEN = "coach_resume_seen"
private const val KEY_MATH_COACH_SEEN = "coach_math_seen"
private const val KEY_RIDDLE_COACH_SEEN = "coach_riddle_seen"

class SettingsCoachPrefsStore(
    private val settings: Settings,
) : CoachPrefsStore {
    override fun hasSeenPlayCoach(): Boolean = settings.getBoolean(KEY_PLAY_COACH_SEEN, false)

    override fun markPlayCoachSeen() {
        settings.putBoolean(KEY_PLAY_COACH_SEEN, true)
    }

    override fun hasSeenLevelsCoach(): Boolean = settings.getBoolean(KEY_LEVELS_COACH_SEEN, false)

    override fun markLevelsCoachSeen() {
        settings.putBoolean(KEY_LEVELS_COACH_SEEN, true)
    }

    override fun hasSeenResumeCoach(): Boolean = settings.getBoolean(KEY_RESUME_COACH_SEEN, false)

    override fun markResumeCoachSeen() {
        settings.putBoolean(KEY_RESUME_COACH_SEEN, true)
    }

    override fun hasSeenMathCoach(): Boolean = settings.getBoolean(KEY_MATH_COACH_SEEN, false)

    override fun markMathCoachSeen() {
        settings.putBoolean(KEY_MATH_COACH_SEEN, true)
    }

    override fun hasSeenRiddleCoach(): Boolean = settings.getBoolean(KEY_RIDDLE_COACH_SEEN, false)

    override fun markRiddleCoachSeen() {
        settings.putBoolean(KEY_RIDDLE_COACH_SEEN, true)
    }

    override fun resetAll() {
        settings.remove(KEY_MATH_COACH_SEEN)
        settings.remove(KEY_RIDDLE_COACH_SEEN)
        settings.remove(KEY_PLAY_COACH_SEEN)
        settings.remove(KEY_LEVELS_COACH_SEEN)
        settings.remove(KEY_RESUME_COACH_SEEN)
    }
}
